// What the search everywhere accepts, as GET /search checks it: the text
// trimmed like PHP's trim(), 2 to 200 characters (code points, not UTF-16
// units), holding a word of two characters at least once folded like the
// server's search text.
import { normalize } from '../components/collection/fold';

export const MIN_QUERY = 2;
export const MAX_QUERY = 200;

/** PHP's trim(): spaces, tabs, line breaks, NUL and vertical tab only. */
const TRIMMED = new Set([' ', '\t', '\n', '\r', '\0', '\u000B']);
export const phpTrim = (text) => {
  const chars = [...String(text ?? '')];
  let start = 0;
  let end = chars.length;
  while (start < end && TRIMMED.has(chars[start])) start += 1;
  while (end > start && TRIMMED.has(chars[end - 1])) end -= 1;
  return chars.slice(start, end).join('');
};

/** True when the text is a search the server runs. */
export const searchable = (text) => {
  const q = phpTrim(text);
  const length = [...q].length;
  if (length < MIN_QUERY || length > MAX_QUERY) return false;
  return normalize(q).split(' ').some((term) => [...term].length >= MIN_QUERY);
};
